var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 13 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Triangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BROWSE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activate-Pion",
    transform: "translate(-215.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-CONTENT"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Section-background",
    fill: "#E0E9FF",
    x: 0,
    y: 0,
    width: 375,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", {
    id: "Home-title",
    transform: "translate(16.000000, 132.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.898567,21.1106364 C205.869273,21.1545773 205.831568,21.1922825 205.787627,21.2215764 C205.603815,21.3441174 205.355468,21.2944478 205.232927,21.1106364 L199.580333,12.6317466 C199.536529,12.5660396 199.513154,12.4888365 199.513154,12.4098665 C199.513154,12.1889526 199.69224,12.0098665 199.913154,12.0098665 L211.21834,12.0098665 C211.29731,12.0098665 211.374513,12.0332417 211.44022,12.0770464 C211.624031,12.1995874 211.673701,12.4479351 211.55116,12.6317466 L205.898567,21.1106364 Z",
    id: "Triangle"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.16b82b787a6d5d4fb398c9cd5cd6566b.svg";
export { ForwardRef as ReactComponent };